// extracted by mini-css-extract-plugin
export default {"page":"ProductPage_page__09Y09","layout":"ProductPage_layout__ZnGi3","skeleton":"ProductPage_skeleton__xi-id","pulse":"ProductPage_pulse__bkspu","error":"ProductPage_error__wPFkO"};